import React, { useEffect, useState } from 'react';
import { formatDeviceTimestamp } from '../utils/timeUtils';

export default function SoilDeviceCard({ device, t, lang }) {
  const [reading, setReading] = useState(null);

  useEffect(() => {
    fetch(`/api/sensor-data/soil7in1/latest/${device.id}`)
      .then((r) => r.json())
      .then((d) => setReading(d))
      .catch(() => {});
  }, [device.id]);

  const data = reading?.data || {};
  const ts = reading?.ts || device.lastUpdated;
  const status = ts && Date.now() - new Date(ts).getTime() <= 10 * 60 * 1000 ? 'online' : 'offline';

  const fmt = (v, unit = '') =>
    v !== undefined && v !== null && Number.isFinite(v)
      ? `${Number(v).toFixed(2)}${unit}`
      : '-';

  const formatDate = (val) => {
    if (!val) return '-';
    const locale = lang === 'he' ? 'he-IL' : lang === 'es' ? 'es-ES' : lang;
    return formatDeviceTimestamp(val, locale);
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">
          🌱 {device.name || device.id}
          {data.in_medium !== undefined && (
            <span className={`badge ms-2 ${data.in_medium ? 'bg-success' : 'bg-secondary'}`}>
              {data.in_medium ? t('inMedium') : t('inAir')}
            </span>
          )}
        </h5>
        <h6 className="card-subtitle mb-2 text-muted">{device.id}</h6>
        <p className="mb-1">{t('status')}: {status.toUpperCase()}</p>
        <table className="table table-sm mb-2">
          <tbody>
            <tr>
              <th>{t('moisture')}</th>
              <td>{fmt(data.moisture_pct, ' %')}</td>
            </tr>
            <tr>
              <th>{t('temperature')}</th>
              <td>{fmt(data.temp_c, ' °C')}</td>
            </tr>
            <tr>
              <th>{t('ec')}</th>
              <td>{fmt(data.ec_mscm, ' mS/cm')}</td>
            </tr>
            <tr>
              <th>{t('ph')}</th>
              <td>{fmt(data.ph)}</td>
            </tr>
            <tr>
              <th>{t('nitrogen')}</th>
              <td>{fmt(data.n_mgkg, ' mg/kg')}</td>
            </tr>
            <tr>
              <th>{t('phosphorus')}</th>
              <td>{fmt(data.p_mgkg, ' mg/kg')}</td>
            </tr>
            <tr>
              <th>{t('potassium')}</th>
              <td>{fmt(data.k_mgkg, ' mg/kg')}</td>
            </tr>
          </tbody>
        </table>
        <p className="mb-0">{formatDate(ts)}</p>
      </div>
    </div>
  );
}
